import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataEntity_Detail_Down_10_Interface } from 'src/app/Interface/DataEntity/10/DataEntity_Detail_Down_10_Interface';
import { DataEntity_Detail_In_10_Interface } from 'src/app/Interface/DataEntity/10/DataEntity_Detail_In_10_Interface';
import { DataEntity_Main_10_Interface } from 'src/app/Interface/DataEntity/10/DataEntity_Main_10_Interface';
import { DataEntity_Resolution_10_Interface } from 'src/app/Interface/DataEntity/10/DataEntity_Resolution_10_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataEntity10Service {

  constructor(private http: HttpClient) { }

  GetSingle(id: Number, dataentity_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Dataentityno10/GetSingle?id=" + id
      + "&dataentity_id=" + dataentity_id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  Submit(
    model_temp: DataEntity_Main_10_Interface,
    detail_In: Array<DataEntity_Detail_In_10_Interface>,
    detail_Down: Array<DataEntity_Detail_Down_10_Interface>,
    resolution: Array<DataEntity_Resolution_10_Interface>,

    DataEntity_id: number,
    Calibration_Id: number,
    Filename: string,

    FolderName: string,

    DeviceSerial: string,
    DeviceCode: string,

    Manufacture_txt: String,
    Type_txt: String,
    Model_txt: String,
    LabAddress_txt: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var detail_list_in  = []
    var detail_list_down = []

    var mesured_list_in = []
    var mesured_list_down = []


    var Indexer: number = 0
    for (let item of detail_In) {
      detail_list_in.push({
        id: item.id,
        main_id: model_temp.id,

        reference_Value: item.reference_Value,
        uncertainty: item.uncertainty,
        converage: item.converage,
      })

      for (let itemDetail of item.mesured) {
        mesured_list_in.push({
          main_id: Indexer,
          mesured: itemDetail+'',
        })
      }

      Indexer++
    }

    Indexer = 0
    for (let item of detail_Down) {
      detail_list_down.push({
        id: item.id,
        main_id: model_temp.id,

        reference_Value: item.reference_Value,
        uncertainty: item.uncertainty,
        converage: item.converage,
      })

      for (let itemDetail of item.mesured_top) {
        mesured_list_down.push({
          main_id: Indexer,
          mesured: itemDetail+'',
          status:1
        })
      }

      for (let itemDetail of item.mesured_mid) {
        mesured_list_down.push({
          main_id: Indexer,
          mesured: itemDetail+'',
          status:2
        })
      }

      for (let itemDetail of item.mesured_top) {
        mesured_list_down.push({
          main_id: Indexer,
          mesured: itemDetail+'',
          status:3
        })
      }

      Indexer++
    }


    var model={
      id:model_temp.id,
      filename: Filename,

      pdf_src: FolderName,

      manufacture: Manufacture_txt,
      type: Type_txt,
      model: Model_txt,


      before: model_temp.before==1,



      unit_error: model_temp.unit_error,
      unit_nominal: model_temp.unit_nominal,
      
      temperature_Air_before: model_temp.temperature_Air_before +'',
      temperature_Air_after: model_temp.temperature_Air_after+'',

      humidity_Air_before: model_temp.humidity_Air_before+'',
      humidity_Air_after: model_temp.humidity_Air_after+'',

      pressure_before: model_temp.pressure_before+'',
      pressure_after: model_temp.pressure_after+'',

    }

    var body = {
      Calibration_id: Calibration_Id,
      dataentity_id: DataEntity_id,
      model: model,
      resolution : resolution,
      detail_In: detail_list_in,
      detail_Down: detail_list_down,
      mesured_In: mesured_list_in,
      mesured_Down: mesured_list_down,
      DeviceSerial: DeviceSerial,
      DeviceCode: DeviceCode,
      labAdderss: LabAddress_txt,

    }


    return this.http.post(environment.BaseUrl + "Daro/Dataentityno10/Submit", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  uploadFile_IN(body){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno10/uploadIn", body).pipe(
      map(data=>{
        return data
      })
    )
  }

  uploadFile_Down(body){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno10/uploadDown", body).pipe(
      map(data=>{
        return data
      })
    )
  }

  uploadPdf(body){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno10/uploadPdf", body).pipe(
      map(data=>{
        return data
      })
    )
  }


}
